import { dataProps, fabricConsumptionProps } from './properties'

export const setTailoringSizeList = (state, payload) => {
    state.list = payload
}    

export const setTailoringSizeData = (state, payload) => {
    state.props = payload
    if(state.props.fabric_consumption_list.length === 0) {
        state.props.fabric_consumption_list.push(JSON.parse(JSON.stringify(fabricConsumptionProps)))
    }
} 

export const resetTailoringSizeData = state => {
    state.props = JSON.parse(JSON.stringify(dataProps))
}

export const addNewTailoringSizeMasterFabricConsumptionRow = state => {

    let key = 0
    state.props.fabric_consumption_list.push(JSON.parse(JSON.stringify(fabricConsumptionProps)))

    state.props.fabric_consumption_list.forEach(element => {
        element.key = key
        key ++
    })

    setTimeout(() => {
        document.getElementById('size_name_'+(key-1)).focus()
    }, 300);
}

export const removeTailoringSizeMasterFabricConsumptionRow = (state, payload) => {

    let key = 0

    state.props.delete_fabric_consumption_list.push(state.props.fabric_consumption_list[payload])

    state.props.fabric_consumption_list.splice(payload, 1)

    if(state.props.fabric_consumption_list.length === 0) {
        state.props.fabric_consumption_list = [JSON.parse(JSON.stringify(fabricConsumptionProps))]
    }

    state.props.fabric_consumption_list.forEach(element => {
        element.key = key
        key ++
    })

}



// WEBPACK FOOTER //
// ./src/store/modules/tailoringSize/mutations.js